// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageAttributes_attributes__fQzZe {
  -webkit-user-select: none;
          user-select: none;
  display: inline-flex;
  align-items: center;
}
.MessageAttributes_attributes__fQzZe > * {
  margin-left: 2px;
}

.MessageAttributes_status__7ABSX {
  width: 15px;
  display: inline-block;
  line-height: 0;
}

.MessageAttributes_editLabel__Xo8B3 {
  color: #8E8E93;
  font-style: italic;
  margin-right: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/MessageGroup/MessageAttributes/MessageAttributes.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;UAAA,iBAAA;EACA,oBAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,WAAA;EACA,qBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AAAF","sourcesContent":[".attributes {\n  user-select: none;\n  display: inline-flex;\n  align-items: center;\n\n  &>* {\n    margin-left: 2px;\n  }\n}\n\n.status {\n  width: 15px;\n  display: inline-block;\n  line-height: 0;\n}\n\n.editLabel {\n  color: #8E8E93;\n  font-style: italic;\n  margin-right: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attributes": `MessageAttributes_attributes__fQzZe`,
	"status": `MessageAttributes_status__7ABSX`,
	"editLabel": `MessageAttributes_editLabel__Xo8B3`
};
export default ___CSS_LOADER_EXPORT___;
